export default __webpack_public_path__ + "static/media/personalDetailshelpMobileHighlight@2x.7ddf89cd.png";